///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2022 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { userTitle, division as divisionTypes } from "./types";

export const initializePendo = user => {
  window.pendo.initialize({
    visitor: {
      id: "EMP-" + user.userId,
      role: userTitle[user.userRole],
      jobTitle: user.title,
      department: user.department,
      code: user.division === divisionTypes.coy ? user.firstName + '.' + user.lastName : ""
      // email:        // Recommended if using Pendo Feedback, or NPS Email
      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
    },

    account: {
      id: "COY" // Required if using Pendo Feedback
      // name:         // Optional
      // is_paying:    // Recommended if using Pendo Feedback
      // monthly_value:// Recommended if using Pendo Feedback
      // planLevel:    // Optional
      // planPrice:    // Optional
      // creationDate: // Optional
      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
    }
  });
};

export default initializePendo;
